if (!customElements.get('slideshow-nav')) {
  customElements.define(
    'slideshow-nav',
    class SlideshowNav extends HTMLElement {
      constructor() {
        super();
        this.onPillClick = this.onPillClick.bind(this);
        this.onScroll = this.onScroll.bind(this);
      }

      connectedCallback() {
        this.slider = this.querySelector('.slideshow');
        this.slides = Array.from(this.querySelectorAll('.slideshow__slide'));
        this.pills = Array.from(this.querySelectorAll('.slideshow__pill'));

        if (!this.slider || this.slides.length === 0) return;

        this.playInitial();

        if (this.slides.length < 2 || this.pills.length === 0) return;

        this.pills.forEach((pill) => pill.addEventListener('click', this.onPillClick));
        this.slider.addEventListener('scroll', this.onScroll, { passive: true });
      }

      // Play the content fade-in for the active slide on page load. The host
      // renders with an `is-loading` class that holds the active slide's content
      // in the hidden start state (see the section's CSS). Removing it on the
      // next frame lets the entrance transition run in — flicker-free, since the
      // content is already hidden at first paint.
      playInitial() {
        void this.slider.offsetWidth;
        requestAnimationFrame(() => this.classList.remove('is-loading'));
      }

      disconnectedCallback() {
        this.pills?.forEach((pill) => pill.removeEventListener('click', this.onPillClick));
        this.slider?.removeEventListener('scroll', this.onScroll);
      }

      onPillClick(event) {
        const index = Number(event.currentTarget.dataset.index);
        const slide = this.slides[index];
        if (!slide) return;

        this.slider.scrollTo({
          left: slide.offsetLeft,
          behavior: 'smooth',
        });
        this.setActive(index);
      }

      onScroll() {
        const index = Math.round(this.slider.scrollLeft / this.slider.clientWidth);
        this.setActive(Math.min(Math.max(index, 0), this.slides.length - 1));
      }

      setActive(index) {
        this.slides.forEach((slide, slideIndex) => {
          slide.classList.toggle('is-active', slideIndex === index);
        });

        this.pills.forEach((pill, pillIndex) => {
          const isActive = pillIndex === index;
          pill.classList.toggle('is-active', isActive);
          if (isActive) {
            pill.setAttribute('aria-current', 'true');
          } else {
            pill.removeAttribute('aria-current');
          }
        });
      }
    }
  );
}
